





















































































































































































































































































































































































































































































































import { Component, Prop } from "vue-property-decorator";
import axios from "axios";
import HacoBase from "../HacoBase";
import {
  ScenarioMargin,
  Scenario,
  holderCalcTypeConst
} from "../model/Scenario";
import { getCalcTypes } from "../model/CalcType";

@Component
export default class ScenarioEditComp extends HacoBase {
  editData: any = {};
  $debugServer!: string;
  unSelectedCoaters: string[] = [];
  calcTypes = getCalcTypes();
  holderCalcTypeConst = holderCalcTypeConst;
  @Prop({ type: String, required: false }) private dialogText!: string;
  mounted(): void {
    if (this.$route.params.id === undefined) {
      return;
    } else {
      const url =
        this.$debugServer +
        "/api/v1_inner/scenario/" +
        this.$route.params.id +
        "/edit";
      // データ取ってくる
      const params: object = this.setAxiosParams(url, "get");
      axios(params)
        .then((response: any): void => {
          this.editData = response.data;
          if (this.$route.params.id === "-1") {
            /** 新規だったら */
            const editMargin: any = this.editData;
            const keys = Object.keys(editMargin.deliveryDateTypes);
            const scenarioMargins = keys.map((key: any) => {
              const scenarioMargin = new ScenarioMargin();
              scenarioMargin.scenarioId = 0;
              scenarioMargin.deliveryDateTypeId = key;
              scenarioMargin.fixedCost = 0;
              scenarioMargin.rate = 0;
              return scenarioMargin;
            });
            const scenario = new Scenario();
            scenario.id = -1;
            scenario.scenarioMargins = scenarioMargins;
            this.editData.scenario = scenario;
          } else {
            Object.keys(this.editData.deliveryDateTypes).forEach(key => {
              if (!this.editData.scenario.scenarioMargins[key]) {
                this.editData.scenario.scenarioMargins[key] = {
                  scenarioId: parseInt(this.editData.scenario.id, 10),
                  deliveryDateTypeId: key,
                  fixedCost: 0,
                  rate: 0
                };
              }
            });
          }

          this.$nextTick((): void => {
            this.markNonSelectedItem(null, "itemDieCuts", "dieCut", "DieCut");
            this.markNonSelectedItem(null, "itemCoaters", "coater", "Coater");
            this.markNonSelectedItem(null, "itemGlues", "glues", "Glue");
            this.markNonSelectedItem(null, "itemCustoms", "customs", "Custom");
          });
        })
        .catch((error: any): void => {
          console.log("[error]", error.response);
          this.toLoginPage(error);
        });
    }
  }

  checkUsedPaper(): void {
    const coaterEle: HTMLSelectElement = document.getElementById(
      "coater"
    ) as HTMLSelectElement;
    const groupCoaters: string[] = this.editData.scenario.groupCoaters;
    interface UsedCoaterPaperSizes {
      [key: string]: number[];
    }
    const usedCoaterPaperSizes: UsedCoaterPaperSizes = this.editData
      .usedCoaterPaperSizes;
    const itemPaperSizeId: string = this.editData.scenario.itemPaperSizeId;

    let item: string;
    this.unSelectedCoaters.length = 0;
    let isUsed: boolean;
    for (item of groupCoaters) {
      isUsed = false;
      let paperSize: number;
      paperCheck: for (paperSize of usedCoaterPaperSizes[item]) {
        if (itemPaperSizeId.toString() === paperSize.toString()) {
          isUsed = true;
          break paperCheck;
        }
      }
      if (isUsed === false) {
        this.unSelectedCoaters.push(item);
      }
    }
    if (
      this.editData.scenario.groupCoaters.length === 0 ||
      this.unSelectedCoaters.length > 0
    ) {
      coaterEle.setCustomValidity(
        this.$t("message.scenarioEdit.error.noCoater") as string
      );
    } else {
      coaterEle.setCustomValidity("");
    }
  }

  markNonSelectedItem(
    e: any = null,
    dataName: string,
    id: string,
    category: string
  ): void {
    const selectEle: HTMLSelectElement = document.getElementById(
      id
    ) as HTMLSelectElement;
    if (id === "coater" && e !== null) {
      this.checkUsedPaper();
    } else {
      if (this.getName(this.editData[dataName]) === "Array") {
        selectEle.setCustomValidity(
          this.$t("message.scenarioEdit.error.no" + category) as string
        );
      } else {
        selectEle.setCustomValidity("");
      }
    }
  }

  onSubmit(back = false): void {
    let bool = false;
    const formElement: HTMLFormElement = document.getElementById(
      "editForm"
    ) as HTMLFormElement;
    if (formElement !== null && formElement.reportValidity() === false) {
      bool = true;
    }

    if (bool === true) {
      return;
    }

    const mes = this.$t("message.editCommon.saveConfirmation");
    const confirmation: boolean = confirm(mes as string);
    if (confirmation === false) {
      return;
    }
    const editData: any = this.editData;
    if (editData.scenario.scenarioName === "") {
      this.$emit(
        "putDialogText",
        this.$t("message.scenarioEdit.error.enterScenarioName")
      );
      return;
    }

    const noUpperLimit: HTMLInputElement = document.getElementById(
      "noUpperLimit"
    ) as HTMLInputElement;
    if (noUpperLimit.checked === true) {
      editData.scenario.impositionLimit = null;
    }
    /** 表記の揺れ対策 */
    interface CategoryObj {
      category: string;
      backTo: string;
      dataName: string;
    }
    const categoryObj: CategoryObj = {
      category: "scenario",
      backTo: "scenario",
      dataName: "scenario"
    };
    const id: number = parseInt(editData.scenario.id, 10);
    this.sendEditData(id, editData, categoryObj, back, this.afterSaving);
  }

  afterSaving(): void {
    void 0;
  }
}
